<script>
  import { External, M } from '../../../external';
  import { onMount } from 'svelte';
  import { ignore } from '../../../Common/tools';

  export let data,
    valid,
    onChange = ignore;

  let result = {
    resourceType: null,
    resourceId: null,
    commentId: null,
    reaction: null
  };

  const service = {
    BASE_URL: `https://${External.serviceApiDomain}/comment/admin`,
    getContexts: async (resourceType) => {
      const url = `${service.BASE_URL}/context?resourceType=${resourceType}`;
      const response = await fetch(url, {
        method: 'GET',
        cache: 'no-cache',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          'X-Website-Hash': External.WebPlatform.hash,
          'X-Admin-Hash': External.Website.hash
        }
      });
      return await response.json();
    },
    getComment: async (commentId) => {
      const url = `${service.BASE_URL}/${commentId}/detail`;
      const response = await fetch(url, {
        method: 'GET',
        cache: 'no-cache',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          'X-Website-Hash': External.WebPlatform.hash,
          'X-Admin-Hash': External.Website.hash
        }
      });

      if (!response.ok) {
        return null;
      }

      return await response.json();
    }
  };

  const blogPosts = {
    data: [],
    fetch: async () => {
      const fetchPage = async (_page) => {
        return new Promise((resolve) => {
          External.Tools.makeWebsiteRequest({
            action: 'listBlogItems',
            data: {
              page: _page,
              type: 0
            },
            onOk: function (response) {
              resolve(response.data);
            }
          });
        });
      };

      const pagination = {
        page: 0,
        hasNextPage: true
      };

      let result = [];
      while (pagination.hasNextPage) {
        const response = await fetchPage(pagination.page);
        if (pagination.page + 1 >= response.pagesCount) {
          pagination.hasNextPage = false;
        }

        result = [
          ...result,
          ...response.items.map((post) => {
            return { id: post.id, name: post.title };
          })
        ];
      }

      blogPosts.data = result;
    }
  };

  const context = {
    isLoading: false,
    data: [],
    fetch: async () => {
      context.isLoading = true;
      context.data = await service.getContexts(result.resourceType);

      // Show blog post title as pretty name for context
      if (result.resourceType === 'blog_post') {
        if (context.data.length > 0 && blogPosts.data.length > 0) {
          context.data.forEach((ctx) => {
            const post = blogPosts.data.find((iter) => '' + iter.id === ctx.resourceId);
            ctx.name = post.name;
          });
        }
      }

      context.isLoading = false;
    }
  };

  const wallPost = {
    isLoading: false,
    data: null,
    fetch: async () => {
      wallPost.isLoading = true;
      wallPost.data = await service.getComment(result.commentId);
      wallPost.isLoading = false;
    }
  };

  const resourceTypes = [
    {
      type: 'standalone',
      name: M.WIDGET
    },
    {
      type: 'blog_post',
      name: M.BLOG_POST
    },
    {
      type: 'wall',
      name: M.WALL_POST
    }
  ];

  const standardReactions = [
    {
      type: 'love',
      name: 'Love'
    },
    {
      type: 'laugh',
      name: 'Laugh'
    },
    {
      type: 'wow',
      name: 'Wow'
    },
    {
      type: 'cry',
      name: 'Cry'
    },
    {
      type: 'angry',
      name: 'Angry'
    },
    {
      type: 'like',
      name: 'Like'
    },
    {
      type: 'dislike',
      name: 'Dislike'
    }
  ];

  const upvoteReactions = [
    {
      type: 'upvote',
      name: 'Upvote'
    },
    {
      type: 'downvote',
      name: 'Downvote'
    }
  ];

  const onResultChange = () => {
    if (result.reaction && (result.commentId || (result.resourceType && result.resourceId))) {
      data.settings = [];
      data.settings.push({
        key: '0',
        value: JSON.stringify(result)
      });

      const reactionMapping = [...standardReactions, ...upvoteReactions].find((iter) => iter.type === result.reaction);
      data.name = `On ${reactionMapping.name}`;
      valid = true;
      onChange();
    } else {
      valid = false;
    }
  };

  const onCommentIdChanged = async () => {
    if (!result.commentId) {
      return;
    }

    await wallPost.fetch();
  };

  onMount(() => {
    blogPosts.fetch();
    if (!data.settings) {
      data.settings = [];
    }
    if (data.settings.length > 0) {
      result = JSON.parse(data.settings[0].value);
    }
    if (result.resourceType) {
      if (result.resourceType === 'wall' && result.commentId) {
        onCommentIdChanged();
      } else {
        context.fetch();
      }
    }
  });
</script>

<div class="col20 f-left small-rules mb-25">
  <h4 class="col20 f-left mt-15 mb-10 t-center" style="line-height:1.4;">{M.WHEN_USER_REACTS_TO_THREAD}</h4>
  <div class="popup-input-wrapper f-left mt-25">
    <div class="info">
      <h5>{M.SELECT_RESOURCE_TYPE}</h5>
    </div>
    <select
      class="page-select"
      bind:value={result.resourceType}
      on:change={() => {
        context.fetch();
        result.resourceId = null;
        result.reaction = null;
        result.commentId = null;
      }}>
      <option value="0" disabled>{M.PLEASE_SELECT}</option>
      {#each resourceTypes as resourceType}
        <option value={resourceType.type}>{resourceType.name}</option>
      {/each}
    </select>
  </div>

  {#if result.resourceType === 'wall'}
    <div class="popup-input-wrapper f-left">
      <div class="info">
        <h5>{M.ENTER_POST_ID}</h5>
      </div>
      <input type="text" bind:value={result.commentId} on:change={onCommentIdChanged} />
    </div>
    {#if result.commentId}
      <div class="popup-input-wrapper f-left">
        <div class="info">
          <h5>{M.CHOOSE_REACTION}</h5>
        </div>
        {#if wallPost.isLoading}
          <div class="col20 f-left t-center mt-5">
            <i class="fa fa-circle-o-notch fa-spin"></i>
          </div>
        {:else if !wallPost.data}
          <div class="col20 f-left t-center mt-5">
            <span>Post not found</span>
          </div>
        {:else if wallPost.data.settings?.reactionType === 'upvote'}
          <select class="page-select" bind:value={result.reaction} on:change={onResultChange}>
            <option value="0" disabled>{M.PLEASE_SELECT}</option>
            {#each upvoteReactions as reaction}
              <option value={reaction.type}>{reaction.name}</option>
            {/each}
          </select>
        {:else}
          <select class="page-select" bind:value={result.reaction} on:change={onResultChange}>
            <option value="0" disabled>{M.PLEASE_SELECT}</option>
            {#each standardReactions as reaction}
              <option value={reaction.type}>{reaction.name}</option>
            {/each}
          </select>
        {/if}
      </div>
    {/if}
  {:else}
    <div class="popup-input-wrapper f-left">
      <div class="info">
        <h5>{M.SELECT_THREAD}</h5>
      </div>
      {#if context.isLoading}
        <div class="col20 f-left t-center mt-5">
          <i class="fa fa-circle-o-notch fa-spin"></i>
        </div>
      {:else if context.data.length === 0}
        <div class="col20 f-left t-center no-data-box white-bg">
          <span>{M.NO_CONTEXT_TO_SELECT}</span>
        </div>
      {:else}
        <select class="page-select" bind:value={result.resourceId} on:change={onResultChange}>
          <option value="0" disabled>{M.PLEASE_SELECT}</option>
          {#each context.data as resource}
            <option value={resource.resourceId}>{resource.name}</option>
          {/each}
        </select>
      {/if}
    </div>
    {#if result.resourceId}
      <div class="popup-input-wrapper f-left">
        <div class="info">
          <h5>{M.CHOOSE_REACTION}</h5>
        </div>
        <select class="page-select" bind:value={result.reaction} on:change={onResultChange}>
          <option value="0" disabled>{M.PLEASE_SELECT}</option>
          {#each standardReactions as reaction}
            <option value={reaction.type}>{reaction.name}</option>
          {/each}
        </select>
      </div>
    {/if}
  {/if}
</div>
